/**
 * Filter slice for the MasterView store.
 *
 * Manages filter panel visibility, active filters, and derived filter count.
 *
 * @internal
 * @module store/slices/filterSlice
 */
import type { StateCreator } from 'zustand';
import type { MasterPatternViewEntity } from '../../types/service.types';
import type { MasterViewState, FilterState, ActiveFilter } from '../types';

export const createFilterSlice = <T extends MasterPatternViewEntity>(): StateCreator<
  MasterViewState<T>,
  [],
  [],
  FilterState
> => (set) => ({
  isFilterPanelOpen: false,
  activeFilters: [],
  activeFilterCount: 0,

  toggleFilterPanel: () =>
    set((state) => ({ isFilterPanelOpen: !state.isFilterPanelOpen })),

  setFilterPanelOpen: (open: boolean) =>
    set({ isFilterPanelOpen: open }),

  setActiveFilters: (filters: ActiveFilter[]) =>
    set({ activeFilters: filters, activeFilterCount: filters.length }),

  clearFilters: () =>
    set({ activeFilters: [], activeFilterCount: 0, columnFilters: [], quickFilterValues: {} }),
});
